// @flow
import React, { useMemo } from 'react';
import Box from "@mui/material/Box";
import useUserData from "../../../../../../../hooks/user/useUserData";
import { muiGridLocales } from "../../../../../../../helpers/muiGridLocales";
import {
	DataGridPremium,
	GRID_AGGREGATION_ROOT_FOOTER_ROW_ID,
	GridToolbar,
	useGridApiRef,
	useKeepGroupedColumnsHidden
} from "@mui/x-data-grid-premium";
import { formatDate } from "../../../../../../../helpers/date";
import _ from "lodash";
import { reportGridsSx } from "../../helpers";

type Props = {};

const VisitsCountries = (props: Props) => {
	const { loading, data, t, generalReport } = props
	const { language, dateFormat } = useUserData()
	const report = useMemo(() => (
		_.orderBy(data, ['exhibitionStartDt', 'weight', 'country'], ['desc', 'asc', 'asc'])
	), [data])
	
	const apiRef = useGridApiRef();
	const initialState = useKeepGroupedColumnsHidden({
		apiRef,
		initialState: {
			density: "standard",
			rowGrouping: {
				model: generalReport ? ['groupingColumn'] : ['exhibitionStartDt']
			},
			aggregation: {
				model: {
					visitorCount: 'sum',
				},
			},
		},
	});
	
	const columns = useMemo(() => [
			...(generalReport ? [{
				field: 'groupingColumn',
				description: t('Exhibition'),
				headerName: t('Exhibition'),
				width: 800,
			}] : []),
			...(!generalReport ? [{
				field: 'exhibitionStartDt',
				description: t('Exhibition Date'),
				headerName: t('Exhibition Date'),
				width: 400,
				valueFormatter: (value, row, column, apiRef) => {
					return Boolean(value) ? `${formatDate(value, dateFormat)}` : null
				},
			}] : []),
			{
				field: 'country',
				description: t('Country'),
				headerName: t('Country'),
				minWidth: 200,
				flex: 1
			},
			{
				field: 'visitorCount',
				description: t('VisitorCount'),
				headerName: t('VisitorCount'),
				flex: 1,
				minWidth: 200,
				type: 'number',
			},
		],
		[dateFormat, generalReport, t]
	)
	
	return (
		<Box style={{ height: 600, width: '100%' }}>
			<DataGridPremium
				apiRef={apiRef}
				sx={reportGridsSx}
				loading={loading}
				initialState={initialState}
				localeText={muiGridLocales(language)}
				rows={report}
				columns={columns}
				slots={{
					toolbar: GridToolbar
				}}
				slotProps={{
					toolbar: { csvOptions: { disableToolbarButton: true } },
					
				}}
				defaultGroupingExpansionDepth={-1}
				getAggregationPosition={(groupNode) =>
					groupNode.depth === -1 ? null : 'footer'
				}
				getCellClassName={(params) => {
					if (
						params.id.toString().startsWith('auto-generated-group-footer')
					) {
						return 'aggr-footer-colored';
					}
				}}
			/>
		</Box>
	);
};

export default VisitsCountries